import { TrackingConstant } from 'client/tracking/constant';

export const commonEventData = {
  action_name: TrackingConstant.ACTION_APPRAISE_VEHICLE,
  action_category: TrackingConstant.USER_ACTION_CATEGORY,
  action_cause: TrackingConstant.ACTION_CAUSE_BUTTON_CLICK,
};
